
// eslint-disable-next-line no-restricted-globals
const ignored = self.__WB_MANIFEST

export default function registerSw(){
  if ("serviceWorker" in navigator) {
    // Register a service worker hosted at the root of the
    // site using the default scope.
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).then(
      (registration) => {
        console.log("Service worker registration succeeded:", registration);
      },
      (error) => {
        console.error(`Service worker registration failed: ${error}`);
      },
    );
  } else {
    console.error("Service workers are not supported.");
  }
}